import { render, staticRenderFns } from "./DeepCustomerEmpathy5.vue?vue&type=template&id=53bfe135&scoped=true&"
import script from "./DeepCustomerEmpathy5.vue?vue&type=script&lang=js&"
export * from "./DeepCustomerEmpathy5.vue?vue&type=script&lang=js&"
import style0 from "./DeepCustomerEmpathy5.vue?vue&type=style&index=0&id=53bfe135&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfe135",
  null
  
)

export default component.exports